import React from "react";
import { Box, Stack } from "@curves/ui-base";
import clsx from "clsx";

const PricingSummary = ({ className, subtotal = 0, discountAmount = 0, total = 0 }) => {
	const hasDiscount = discountAmount > 0;
	const displayTotal = hasDiscount ? total : subtotal;

	return (
		<Box className={clsx("pos-amount-summary", className)}>
			<Stack className="detail-row" justifyContent="space-between" alignItems="center">
				<Box className={clsx({ "font-weight-medium": !hasDiscount })}>商品總價</Box>
				<Box className={clsx({ "font-weight-medium": !hasDiscount })}>${subtotal.toLocaleString()}</Box>
			</Stack>

			{/* 折抵金額 - 只有有折扣時才顯示 */}
			{hasDiscount && (
				<Stack className="detail-row" justifyContent="space-between" alignItems="center">
					<Box className="text-error">折抵金額</Box>
					<Box className="text-error">-${discountAmount.toLocaleString()}</Box>
				</Stack>
			)}

			<Stack className="detail-row" justifyContent="space-between" alignItems="center">
				<Box className="font-weight-medium">總金額</Box>
				<Box className="pos-total-price font-weight-blod">${displayTotal.toLocaleString()}</Box>
			</Stack>
		</Box>
	);
};

export default PricingSummary;
